
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80.763 69.002"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"google_drive","transform":"translate(-5.919 -5)"}},[_c('path',{attrs:{"id":"Path_1316","data-name":"Path 1316","fill":"#fbce4b","d":"M100.257 5h28.919l25.737 44.97-25.555 2.755-8.622-13.31z","transform":"translate(-68.231)"}}),_c('path',{attrs:{"id":"Path_1317","data-name":"Path 1317","fill":"#dfb53d","d":"M174.257 129.36l6.849 10.555h27.328z","transform":"translate(-121.752 -89.945)"}}),_c('path',{attrs:{"id":"Path_1318","data-name":"Path 1318","fill":"#3476dd","d":"M127.68 167.5l-13.652 24.032H61.171l-11.847-23.466 37.952-.566z","transform":"translate(-40.998 -117.53)"}}),_c('path',{attrs:{"id":"Path_1319","data-name":"Path 1319","fill":"#055bd8","d":"M71.585 167.5l-14.16 24.032L83.53 167.5z","transform":"translate(-37.252 -117.53)"}}),_c('path',{attrs:{"id":"Path_1320","data-name":"Path 1320","fill":"#15a864","d":"M20.173 74L5.919 49.97 32.026 5l1.759 3.028 6.68 31.461-6.132 10.481z"}}),_c('path',{attrs:{"id":"Path_1321","data-name":"Path 1321","fill":"#129155","d":"M100.257 5l8.443 34.489 5.813-10.537z","transform":"translate(-68.231)"}})])])
          )
        }
      }
    